import { asyncComponent } from 'js/file_viewer/core/utils/suspense';
/**
 * Resolves a renderer for the error preview type.
 * Used as a fallback externally if we fail to load a rederer.
 * @param fileExtension
 */
export const AsyncPreviewError = asyncComponent('PreviewError', () => import('js/file_viewer/preview_error/preview_error'));
//# sourceMappingURL=async_preview_error.preenvesnextjs.map
